import { render, staticRenderFns } from "./box-border-icon.vue?vue&type=template&id=31c2a636&scoped=true&"
import script from "./box-border-icon.vue?vue&type=script&lang=ts&"
export * from "./box-border-icon.vue?vue&type=script&lang=ts&"
import style0 from "./box-border-icon.vue?vue&type=style&index=0&id=31c2a636&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2a636",
  null
  
)

export default component.exports